import axios from '@utils/axios';

export async function getSystemConfig(): Promise<SystemItem> {
  const result = await axios.get('/api/system/config');
  return result?.data;
}

export async function getSystemProductList(): Promise<SystemItem> {
  const result = await axios.get('/api/system/product_list');
  return result?.data;
}

export async function getSystemShortUrl(params: {
  long_url: string;
}): Promise<string> {
  const result = await axios.post(
    '/api/system/short_url',
    { ...params },
    {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  );

  return result?.data?.url || '';
}
